<template>
  <div class="xfooter">
    <div class="xfooter_top">
      <div class="cell">新县全域旅游</div>
      <div class="line">|</div>
      <div class="cell">宁IPC18018256</div>
      <div class="line">|</div>
      <div class="cell">联系人：蒋先生</div>
      <div class="line">|</div>
      <div class="cell">联系电话：400-220-366</div>
    </div>
    <div class="xfooter_bottom">
      版权所有：新县全域旅游局Copyright©2020-2029 All rights reserved 宁IPC18018256号-1
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },

  methods: {},
}
</script>

<style lang="less" scoped>

.xfooter {
  font-family: "微软雅黑";
  color: #fff;
  height: 128px;
  background: #02d4d5;
  margin-top: 20px;
  .xfooter_top {
    width: 1200px;
    font-size: 20px;
    margin: 0 auto;
    display: flex;
    justify-content:space-around;
    height: 66px;
    align-items: center;
    border-bottom: 1px solid #fff;
  }
  .xfooter_bottom {
    text-align: center;
    height: 60px;
    line-height: 60px;
  }
}
</style>
